<template>
    <v-dialog v-model="show_dialog" width="400">
        <v-card>
            <v-card-title class="primary_2 text-h6 white--text py-2">
                Edit Loan Status
            </v-card-title>
            <v-card-text class="mt-6">
                <v-select
                    v-model="loan_status"
                    outlined
                    :items="loan_status_list"
                    item-text="label"
                    item-value="value"
                    label="Loan Status"
                    dense
                >
                </v-select>
                <v-row v-if="loan_status == 'disbursed'">
                    <v-col cols="6" class="py-0">
                    <div>Disbursement Date</div>
                    <v-menu
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="disbursement_date"
                            placeholder="Select Disbursement Date"
                            prepend-inner-icon="mdi-calendar"
                            required
                            :rules="$rules.REQUIRED_FIELD"
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                            class="stepper-content-data"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="disbursement_date"
                        no-title
                        >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="dateMenu = false">
                            Cancel
                            </v-btn>
                            <v-btn text color="primary" @click="dateMenu = false">
                            OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                    </v-col>
                    <v-col cols="6" class="py-0">
                    <div>Disbursed Amount</div>
                    <v-text-field
                        v-model="disbursed_amount"
                        outlined
                        dense
                        prepend-inner-icon="mdi-currency-inr"
                        :rules="$rules.AMOUNT"
                        placeholder="Enter Disbursed Amount"
                        required
                    ></v-text-field>
                    </v-col>
                </v-row>
                <v-text-field 
                    class="mt-3"
                    dense 
                    outlined 
                    v-model="loan_sub_status"
                    label="Loan Sub Status"
                    hide-details
                ></v-text-field>
                <v-textarea
                    class="mt-3"
                    dense
                    outlined
                    v-model="remark"
                    label="Comment"
                    auto-grow
                    rows="2"
                    hide-details
                ></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="show_dialog = false" outlined color="red">Cancel</v-btn>
                <v-btn :loading="btn_loader" @click="updateLoanStatus()" elevation="0" color="success">Update</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data() {
        return {
            show_dialog: false,
            loan_id: '',
            loan_status: '',
            loan_status_list: [],
            loan_sub_status: '',
            remark: '',
            dateMenu: false,
            disbursement_date: '',
            disbursed_amount: '',
            btn_loader: false
        }
    },
    methods: {
        openDialog(data) {
            this.loan_id = data.loan_id;
            this.disbursement_date = data.disbursement_date || '';
            this.disbursed_amount = data.disbursed_amount || '';
            this.loan_status = data.loan_status || '';
            this.loan_sub_status = data.loan_sub_status || '';
            this.remark = data.remark || '';
            this.show_dialog = true;
        },
        getLoanStatusList() {
            let self = this;
            const successHandler = (response) => {
               this.loan_status_list = response.data.result;
            };
            const finallyHandler = () => {};
            self.request_GET(
                self,
                self.$urls.GET_OFFER_STATUS_LIST,
                {},
                successHandler,
                null,
                null,
                finallyHandler,
            );
        },
        updateLoanStatus() {
            let self = this;
            this.btn_loader = true;
            let look_up_key = this.loan_id;
            let formData = {};
            formData["status"] = this.loan_status;
            formData["sub_status"] = this.loan_sub_status;
            formData["remark"] = this.remark;
            if(this.loan_status == "disbursed") {
                formData["disbursal_date"] = this.disbursement_date;
                formData["disbursed_amount"] = this.disbursed_amount;
            }
            
            const successHandler = () => {
                this.btn_loader = false;
                self.show_dialog = false;
                this.loan_status = '';
                this.loan_sub_status = '';
                this.remark = '';
                this.disbursement_date = '';
                this.disbursed_amount = '';
                this.$emit("reload");
            };

             self.request_PATCH(
                self,
                self.$urls.UPDATE_OFFER_STATUS,
                `${look_up_key}/`,
                formData,
                successHandler,
                null,
                null,
                null
            );
        }
    },
    created() {
        this.getLoanStatusList();
    }
}
</script>